// Store top.mail.ru counter
export function tmrPushPageView(user_id, id) {
    const _tmr = (window._tmr ||= []);

    _tmr.push({
        id,
        type: "pageView",
        start: new Date().getTime(),
        ...(user_id && { userid: user_id }),
        ...(user_id && { VKPlayID: user_id }),
    });
}

export function tmrPushStartForegroundTimespent(id, activity) {
    const _tmr = (window._tmr ||= []);
    _tmr.push({
        id,
        type: "startForegroundTimespent",
        activity,
    });
}

export function setTmr(user_id) {
    if (document.getElementById("topmailru-code") || document.getElementById("tsmg_store")) {
        return;
    }

    const _tmr = (window._tmr ||= []);

    tmrPushPageView(user_id, "3247783");
    tmrPushPageView(user_id, "3252498");
    tmrPushStartForegroundTimespent("3252498", 73);

    if (user_id) {
        _tmr.push({ type: "setUserID", userid: user_id });
        _tmr.push({ type: "setUserParams", params: { VKPlayID: user_id } });
    }

    (function (d, w, id) {
        if (d.getElementById(id)) return;
        const ts = d.createElement("script");

        ts.type = "text/javascript";
        ts.async = true;
        ts.id = id;
        ts.src = "https://top-fwz1.mail.ru/js/code.js";
        const f = function () {
            const s = d.getElementsByTagName("script")[0];

            if (s) {
                s.parentNode.insertBefore(ts, s);
            }
        };

        if (w.opera === "[object Opera]") {
            d.addEventListener("DOMContentLoaded", f, false);
        } else {
            f();
        }
    })(document, window, "topmailru-code");
}

export function tmrPushEvent(action, label = null, developer_id = null, game_id = null) {
    const goalParams = {
        category: "developers",
        action,
        label,
        developer_id,
        game_id,
        url: location.pathname,
    };

    const _tmr = (window._tmr ||= []);
    _tmr.push({ id: "3252498", type: "reachGoal", goal: "vkplay", params: goalParams });
}

export function tmrPushImageEditorEvent(action, gameCommonInfo, form) {
    let label = "Изображения";
    switch (form.cl_name) {
        case "GameFeaturingLaunchForm": {
            label = "Базовое промо";
            break;
        }
        case "HighlightEditForm": {
            label = "Скриншоты";
            break;
        }
        default: {
            break;
        }
    }
    const developer_id = gameCommonInfo?.developer?.id ?? null;
    const game_id = gameCommonInfo?.game?.id ?? null;
    tmrPushEvent(action, label, developer_id, game_id);
}
